import React, { Component } from 'react';
import { connect } from 'react-redux';
import FocusTrap from 'focus-trap-react';

// wraps react-focus-trap
class WrappedFocusTrap extends Component {

    render() {
        if (!this.props.useFocusTrap) {
            return this.props.children;
        }

        const props = {...this.props};
        delete props.children;
        delete props.useFocusTrap;

        return (
            <FocusTrap {...props}>
                {this.props.children}
            </FocusTrap>
        )
    }
}

const mapStateToProps = state => {
    return {
        useFocusTrap: !!state?.ui?.useFocusTrap,
    }
}

export default connect(mapStateToProps)(WrappedFocusTrap)

